import { Fragment } from "react";
import { Trans, useTranslation } from "react-i18next";

import { type NotificationMessageSegment } from "../lib/getNotificationMessage";

type Props = {
    senderName: string;
    segments: NotificationMessageSegment[];
};

const EMPHASIS_CLASS_NAME = "font-ant-strong";

export const NotificationMessage = ({ senderName, segments }: Props) => {
    const [t] = useTranslation();

    const renderSegment = (segment: NotificationMessageSegment) => {
        switch (segment.kind) {
            case "text":
                return t(segment.i18nKey, segment.values);
            case "emphasizedText":
                return (
                    <Trans
                        i18nKey={segment.i18nKey}
                        values={segment.values}
                        components={{ notif: <span className={EMPHASIS_CLASS_NAME} /> }}
                    />
                );
            case "entityTitle":
                return <span className={EMPHASIS_CLASS_NAME}>{segment.title}</span>;
            case "plain":
                return segment.text;
        }
    };

    return (
        <>
            <span className={EMPHASIS_CLASS_NAME}>{senderName}</span>
            {segments.map((segment, index) => (
                <Fragment key={index}> {renderSegment(segment)}</Fragment>
            ))}
        </>
    );
};
